<template>
  <v-container>
    <v-progress-linear indeterminate />
  </v-container>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useMainStore } from "@/stores/mainStore";

const route = useRoute();
const router = useRouter();
const mainStore = useMainStore();

onMounted(() => {
  const status = route.query.redirect_status;

  if (status === "succeeded" || status === "processing") {
    mainStore.loadOrganizations();
    router.replace({ name: "profile" });
    return;
  }

  router.replace({
    name: "payment-invoice",
    params: {
      licence_id: route.params.licence_id,
      invoice_id: route.params.invoice_id
    }
  });
});
</script>
